import withType from 'components/common/hoc/withType'
import BOTCareerDescriptionTeaser from './BOTCareerDescriptionTeaser'

export default withType({ type: 'BOTCareerDescriptionTeaser' })(BOTCareerDescriptionTeaser)
